// src/data/about.js
export const about = {
  hero: {
    title: "About Us",
    subtitle:
      "BVJAD(भटके विमुक्त जाती व जमाती आदिवासी ज्ञानपीठ) - Ekalvya Ashram School",
  },
  mission:
    "To improve lives of Nomadic & Denotified Tribe members through an integrated developmented program concentrating in the areas of education, healthcare, legal advocacy, and policy reforms.",
  vision:
    "India where every child - no matter where they are born - has the skills, confidence, and opportunities to create change in their communities.",
  stats: [
    { label: "Students Educated", value: "1000+" },
    { label: "Volunteers", value: "50+" },
    { label: "Taluka Covered", value: "5" },
    { label: "District Presence", value: "3" },
  ],
  challenges: [
    {
        title: "Limited infrastructure",
        text: "Children often sleep on mats, lack benches, books, and sports materials.",
    },
    {
        title: "High Dropout Rates",
        text: "Due to migration, poverty, and lack of resources.",
    },
    {
        title: "Language barriers",
        text: "Students come with diverse mother tongues; teachers first teach Marathi, then English.",
    },
    {
        title: "Social challenges",
        text: "Early marriage, gender bias, and stigma around education for girls.",
    },
  ],
  helpus: [
    {
      title: "Improve School Infrastructure",
      text: "Help us build digital classrooms, libraries, and sanitation facilities.",
    },
    {
      title: "Nutrition Support",
      text: "Contribute by providing a better diet, meals, and fruits.",
    },
    {
      title: "Sports Coaching & Equipment",
      text: "Provide sports gear, professional coaching for boxing, cricket, and more.",
    },
    {
      title: "Donate Books & Notebooks",
      text: "Improve children’s learning directly by providing textbooks, notebooks, and stationery.",
    },
    {
      title: "Financial Contributions",
      text: "Support us through donations to expand our programs.",
    },
    {
      title: "Volunteer Your Time",
      text: "Create lasting impact in children’s lives.",
    },
  ],
  main_events: [
        {
        year: 1990,
        title: "Founded",
        funded: "",
        text: "Bhatke Vimukt Jati va Adivasi Dnyanpeeth (BVJAD) was founded by Ramkrishna Mane to serve Nomadic and Denotified Tribes in Karmala, Maharashtra—starting with small learning circles.",
      },
      {
        year: "1999 - Till Date",
        title: "Eklavya Ashram School Established",
        funded: "Govt. of Maharashtra - Department of Social Welfare",
        text: "Opened a fully residential, government-recognized school—providing education, meals, and safe housing for NT/DNT children.",
      }
  ],
  timeline:
  [
      {
        year: 1997,
        title: "Economic Development (Revolving Funds)",
        funded: "Indo German Social Nomadic and DE-notified Services Society, Pune (IGSSS)",
        text: "Covered: Karmala Block—6 villages; benefited 26 families.",
      },
      {
        year: 1997,
        title: "Health Camps for Women & Children",
        funded: "IGSSS Pune",
        text: "Covered: 5 villages of Karmala Block—100 women and 200 children from nomadic tribes.",
      },
      {
        year: "1997–1999",
        title: "Govt. Scheme Facilitation & Linkage Support",
        funded: "IGSSS Pune",
        text: "Covered: 46 villages in Karmala Block; supported 500 families to access various government schemes through the organization.",
      },
      {
        year: 1997,
        title: "Non-Formal Education",
        funded: "IGSSS Pune",
        text: "Covered: 10 villages of Karmala Block; reached 300 children from NT/DNT/ST families.",
      },
      {
        year: 1997,
        title: "Night Classes for Child Labour",
        funded: "IGSSS Pune",
        text: "Reached 100+ child labourers by providing education after working hours.",
      },
      {
        year: 1997,
        title: "Community Awareness Training",
        funded: "IGSSS Pune",
        text: "Focus: health awareness, superstitious practices, legal aid, and government schemes. Covered: 30 villages in Karmala Block for NT/DNT/ST communities.",
      },
      {
        year: 1997,
        title: "BPL Survey for Central Government Schemes",
        funded: "Karmala Municipal Corporation",
        text: "Covered: 700 BPL families across Karmala city.",
      },
      {
        year: 1997,
        title: "Youth Training (NGO Management & Human Development)",
        funded: "AFARM Pune",
        text: "Covered: 1000 youth workers from different villages in Maharashtra (at Karmala).",
      },
      {
        year: 1998,
        title: "Balwadi / Kindergarten Project",
        funded: "IGSSS Pune",
        text: "Served NT/DNT/ST families of Mangi village in Karmala Block.",
      },
      {
        year: 1998,
        title: "Adolescent Girl Development",
        funded: "AFARM Pune",
        text: "Covered: 50 girls from NT/DNT/ST families of Mangi village in Karmala Block.",
      },
      {
        year: 1999,
        title: "Women Self-Help Groups",
        funded: "IGSSS Pune",
        text: "Enabled women from NT/DNT/SC families in 4 villages of Karmala Block towards economic sustainability.",
      },
      {
        year: "1999–2001",
        title: "Goat Rearing for Nomadic Tribe",
        funded: "AFARM Pune",
        text: "Covered: 25 families from 10 villages of Karmala Block.",
      },
      {
        year: "1999–2005",
        title: "Women & Children Development (Health + Nutrition)",
        funded: "Catholic Relief Services, Pune",
        text: "Provided basic medical facilities and nutritious food to pregnant mothers and children (0–36 months) in 6 villages of Karmala Block.",
      },
      {
        year: "1997–2006",
        title: "Support Centre (Govt. Scheme Linkages)",
        funded: "IGSSS Pune",
        text: "Linked government schemes with ~1500 NT/DNT/ST families of Karmala Block.",
      },
      {
        year: 2005,
        title: "Sustainable Orphanage & Income Generation",
        funded: "Consulate General of German Embassy, Mumbai",
        text: "Activities: vegetable gardening + dairy farming in Karmala Block (Solapur). Output: 50 fruit trees planted and milk provided to 100 children.",
      },
      {
        year: "2009–2021",
        title: "Education, Health & Community Development (VJNT) — Pune",
        funded: "Ashraya Initiative for Children",
        text: "Education and health programme for children (3–14 years) from 25 slum areas in Yerwada, Pune.",
      },
      {
        year: 2019,
        title: "Weekend Learning Circles",
        funded: "",
        text: "Launched informal learning program to educate students about history, civics, and general aptitude.",
      },
  ],
  geography:
    "Our residential school is based in Karmala, Solapur District, Maharashtra. Children come not only from Karmala but also nearby blocks and districts including \n 1. Madha (Solapur) \n 2. Karjat (Ahilyanagar) \n 3. Jamkhed (Ahilyanagar) \n 4. Indapur (Pune).",
  legal: [
    { act: "Societies Registration Act, 1860", reg: "MH-2477/90/Solapur", date: "15/05/1990" },
    { act: "Bombay Public Trust Act, 1950", reg: "F-2418/90/Solapur", date: "16/08/1990" },
    { act: "Foreign Contribution Regulation Act (FCRA)", reg: "083980034", date: "26/06/2000" },
    { act: "12A Reg. Certificate", reg: "AABTB2790FE20216", date: "01/01/2021" },
    { act: "80G Reg. Certificate", reg: "AABTB2790FF20214", date: "01/10/2021" },
    { act: "CSR Reg. Certificate", reg: "CSR00014902", date: "17/09/2021" },
    { act: "NGO Darpan Unique ID", reg: "MH/2018/0217598", date: "28/11/2021" },
    { act: "PAN", reg: "AABTB2790F", date: "16/08/1990" },
  ],
};

export const team = [
  {
    name: "Ramkrishna Babasaheb Mane",
    role: "Founder & President",
    avatar:
      "https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=240&auto=format&fit=facearea&facepad=2&h=240",
  },
  {
    name: "Swati Ramkrishna Mane",
    role: "Community Partnerships",
    avatar:
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=240&auto=format&fit=facearea&facepad=2&h=240",
  },
  {
    name: "Sangram Ramkrishna Mane",
    role: "Vice President",
    avatar:
      "https://images.unsplash.com/photo-1547425260-76bcadfb4f2c?q=80&w=240&auto=format&fit=facearea&facepad=2&h=240",
  }
];
